import React from "react";
import * as S from "../styles";

var SubMenu = function SubMenu(_ref) {
  var e = _ref.links,
      t = _ref.cards,
      a = _ref.promos,
      r = _ref.handleSubLinkClick,
      c = _ref.renderLinkAs;
  return React.createElement(React.Fragment, null, React.createElement(S.SubMenuSectionWrapper, {
    key: "links"
  }, e.map(function (e) {
    return React.createElement(S.ProductLink, {
      key: e.slug,
      "data-testid": e.slug,
      href: e.url,
      onClick: function onClick() {
        return r(e.tags[0], e.label);
      },
      as: c || void 0
    }, e.label);
  })), React.createElement(S.SubMenuSectionWrapper, {
    key: "cards"
  }, t.map(function (e) {
    return React.createElement(S.ProductCard, Object.assign({
      key: e.slug,
      testIDPrefix: "cards"
    }, e));
  })), React.createElement(S.SubMenuSectionWrapper, {
    key: "promos"
  }, a.map(function (e) {
    return React.createElement(S.PromoCard, Object.assign({
      key: e.product.slug
    }, e));
  })));
};

export default SubMenu;